module.exports = __webpack_public_path__ + "img/arms.b0054e63.jpg";